import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RiskRulesService } from '../services/risk-rules.service';

export const riskRuleListResolver: ResolveFn<void> = (
    route: ActivatedRouteSnapshot,
) => {
    const riskRulesService = inject(RiskRulesService);
    const riskRuleType = route.paramMap.get('riskRuleType');

    if (riskRuleType) {
        try {
            riskRulesService.loadRiskRuleListAttributes(
                riskRuleType === 'AbsoluteRules',
            );
        } catch (error) {
            console.error('Error setting current group type:', error);
            throw error;
        }
    } else {
        throw new Error('riskRuleType parameter is missing in the route');
    }
};

export const riskRuleDetailResolver: ResolveFn<void> = (
    route: ActivatedRouteSnapshot,
) => {
    const riskRulesService = inject(RiskRulesService);
    const riskRuleType = route.paramMap.get('riskRuleType');
    const id = route.paramMap.get('id');

    if (riskRuleType) {
        try {
            riskRulesService.loadSelectableData();
            riskRulesService.loadRiskRuleDetailAttributes(
                riskRuleType === 'AbsoluteRules',
            );
            if (id) riskRulesService.loadDetailData(Number(id));
        } catch (error) {
            console.error('Error setting current group type:', error);
            throw error;
        }
    } else {
        throw new Error('riskRuleType parameter is missing in the route');
    }
};
